var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _c("header", { staticClass: "row align-items-center no-margin" }, [
      _c("div", { staticClass: "col" }, [
        _c(
          "button",
          {
            staticClass: "btn no-bg",
            on: {
              click: function($event) {
                return _vm.setPosSection("choose-product")
              }
            }
          },
          [_c("i", { staticClass: "fas fa-chevron-left" })]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "orders-section" },
      [
        _c("orderlist-view", {
          staticClass: "order-list",
          attrs: { disabled: "true" }
        }),
        _vm._v(" "),
        _c("totalprice-view", {
          staticClass: "total-price",
          staticStyle: { "border-top": "solid 1px #F2F2F2" },
          attrs: { disabled: "true" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "payment-section" }, [
      _vm.posSettings.payment.is_active
        ? _c("div", { staticClass: "wrapper-payment-methods" }, [
            _c("div", { staticClass: "col no-padding mb-2 title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("apps.pos.message.paymentmethod")) +
                  ":\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "btn-group btn-group-payment-methods",
                  attrs: { role: "group" }
                },
                _vm._l(_vm.paymentMethodsButtons, function(item, index) {
                  return _c(
                    "button",
                    {
                      key: index,
                      class: item.btnClass,
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.handleSelectPaymentMethod(item.name)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(item.text) + "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col no-padding mt-2 helper" }, [
              _c("i", {
                staticClass: "fa fa-info-circle",
                attrs: { "aria-hidden": "true" }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("apps.pos.message.paymentmethodhelper")) +
                    "\n        "
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper-payment-form" },
        [
          _vm.paymentMethod === _vm.POS_PAYMENT_METHOD.CASH
            ? _c("calculator-view", {
                attrs: { compare: true, disabled: _vm.disabledBtnEnter },
                on: { submit: _vm.onSubmit }
              })
            : _c("other-payment-form", {
                attrs: {
                  total: _vm.totalPrice,
                  paymentMethod: _vm.paymentMethod,
                  disabled: _vm.disabledBtnEnter
                },
                on: { submit: _vm.onSubmit }
              })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82d8d2ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82d8d2ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/include/Payment.vue
// module id = null
// module chunks = 